import i18next from 'i18next'
import { CHANGE_PASS_MUTATION, apolloClient } from 'src/common/apollo'
import { authStore } from 'src/stores'
import { action, observable, store } from '~/common/mobx.decorator'

@store()
class CommonChangePasswordStore {
	@observable confirm = false

	@action
	changePassword = async (variables, { setErrors, resetForm }) => {
		try {
			const {
				data: { changePassword },
			} = await apolloClient.mutate({
				mutation: CHANGE_PASS_MUTATION,
				variables,
			})

			if (changePassword?.success) {
				this.toggleConfirm(true)
				resetForm()
				authStore.changeToken(changePassword?.authToken)
			}
		} catch (error) {
			const { graphQLErrors } = error
			if (graphQLErrors?.[0]?.extensions?.error === 'invalid_password') {
				setErrors({ oldPassword: i18next.t('$ERRORS.INCORRECT_CURRENT_PW') })
			}
		}
	}

	@action
	toggleConfirm = async (confirm) => {
		this.confirm = confirm
	}
}

export const commonChangePasswordStore = new CommonChangePasswordStore()
